import * as service from './service'
export default {
  namespace: 'recruitCheckVehicle',
  state: {
    supportCarData: []
  },
  effects: {
    * getSupportCarList ({ payload }, { call, put }) {
      const res = yield call(service.getSupportCarList, payload)
      yield put({
        type: 'save',
        payload: {
          supportCarData: res.data.data
        }
      })
      return res.data
    }
  },
  reducers: {
    save (state, { payload }) {
      return { ...state, ...payload }
    }
  }
}
